import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

export const loginSlice = createSlice({
  name: 'login',
  initialState : {
    loginPopup: false,
    type: ""
  },
  reducers: {
    setLoginPopup: (state, action) => {
      state.loginPopup = action.payload;
    },

    setopenMenuBar: (state, action) => {
      state.type = action.payload;
    },

    toggleLoginPopup: (state, action) => {
      if (action.payload !== 'undefined' && typeof action.payload === 'boolean') {
        state.loginPopup = action.payload
        return;
      }
      state.loginPopup = !state.loginPopup;
    },
  }
})

const loginReducer = loginSlice.reducer;
const loginSliceName = loginSlice.name;
const useLoginStore = () => useSelector((state) => state.login);
export const { setLoginPopup, setopenMenuBar, toggleLoginPopup } = loginSlice.actions;

export {
  loginSliceName,
  loginReducer,
  useLoginStore
};